import { GenIcon } from '../helpers/IconBase.es.js';

const PlusCircleOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.75 12.25C3.75 7.55558 7.55558 3.75 12.25 3.75C16.9444 3.75 20.75 7.55558 20.75 12.25C20.75 16.9444 16.9444 20.75 12.25 20.75C7.55558 20.75 3.75 16.9444 3.75 12.25ZM12.25 2.25C6.72715 2.25 2.25 6.72715 2.25 12.25C2.25 17.7728 6.72715 22.25 12.25 22.25C17.7728 22.25 22.25 17.7728 22.25 12.25C22.25 6.72715 17.7728 2.25 12.25 2.25ZM12.25 7.15234C12.6642 7.15234 13 7.48813 13 7.90234V11.5H16.5978C17.012 11.5 17.3478 11.8358 17.3478 12.25C17.3478 12.6642 17.012 13 16.5978 13H13V16.598C13 17.0122 12.6642 17.348 12.25 17.348C11.8358 17.348 11.5 17.0122 11.5 16.598V13H7.90216C7.48795 13 7.15216 12.6642 7.15216 12.25C7.15216 11.8358 7.48795 11.5 7.90216 11.5H11.5V7.90234C11.5 7.48813 11.8358 7.15234 12.25 7.15234Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { PlusCircleOutlined };
